import React from 'react'
import PropTypes from 'prop-types'
import VisuallyHidden from '@reach/visually-hidden'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'

import { Button } from 'library'
import styles from './styles.module.scss'

const propTypes = {
  /**
   * Function called to close parent element
   */
  onClick: PropTypes.func,

  /**
   * Sets the text for alert close button.
   */
  closeLabel: PropTypes.string,

  /**
   * Change close button icon
   */
  icon: PropTypes.string || PropTypes.array,
}

const defaultProps = {
  onClick: () => {},
  closeLabel: 'Close',
  icon: 'times',
}

const CloseButton = ({ className, onClick, icon, closeLabel, ...props }) => (
  <div>
    <Button
      {...props}
      className={classNames(className, styles.closeButton)}
      isLink
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} />
      <VisuallyHidden>{closeLabel}</VisuallyHidden>
    </Button>
  </div>
)

CloseButton.displayName = 'CloseButton'
CloseButton.propTypes = propTypes
CloseButton.defaultProps = defaultProps

export default CloseButton
